import { useMemo, useCallback, useState, useEffect } from 'react';

export function useCheckboxState({
  defaultValue=false,
  filterKey,
  setFilters,
  queryKey=filterKey,
  updateQuery,
}) {
  let [ checked, setChecked ] = useState(defaultValue);

  useEffect(() => {
    setFilters(x => {
      let newValue = checked || null;

      if (x[filterKey] === newValue) return x;

      return { ...x, [filterKey]: newValue };
    });

    updateQuery({ [queryKey]: checked || undefined });
  }, [checked]);

  return {
    checked,
    setChecked,
  };
}
